if(!customElements.get('bie-extra-popup')){
 customElements.define('bie-extra-popup',class extends HTMLElement{
  connectedCallback(){
   this.dialog=this.querySelector('dialog');
   this.pending=null;
   this.onAdded=event=>{
    if(event.target.closest('bie-extra-popup')===this){
     this.pending=null;
     if(this.dialog.open)this.dialog.close();
     return;
    }
    if(event.target.querySelector('form')?.getAttribute('id')!==this.dataset.ticketForm||this.dialog.open)return;
    try{this.dialog.showModal()}catch{return}
    this.pending=event.detail;
    event.preventDefault();
   };
   this.onClose=()=>{
    const pending=this.pending;
    this.pending=null;
    if(pending){
     if(pending.cart){pending.cart.renderContents(pending.response)}
     else{window.location.assign(window.routes.cart_url)}
    }
   };
   document.addEventListener('bie:product-added',this.onAdded);
   this.dialog.addEventListener('close',this.onClose);
   this.querySelector('.bie-extra-dialog__decline').addEventListener('click',()=>this.dialog.close());
   this.dialog.addEventListener('click',event=>{if(event.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)this.dialog.close()}});
  }
  disconnectedCallback(){
   document.removeEventListener('bie:product-added',this.onAdded);
   this.dialog.removeEventListener('close',this.onClose);
  }
 });
}

